// src/pages/unauthorized/Unauthorized.jsx

const EmailValidation = () => {
  return (
    <div className="container">
      <h1>Email validation</h1>
    </div>
  );
};

export default EmailValidation;